// extracted by mini-css-extract-plugin
export default {"card":"card_card__RbhjP","surface":"card_surface__U+pii","danger":"card_danger__LUQRB"};